module.exports = __webpack_public_path__ + "media/src/application/media/main-bg-c843d612d603d4ac7d7588ccd85ef8ba.png";